/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import authHeader from "./auth-header";


import { config } from '../config';




const getProvinces = async () => {
  let parms = {
    path: "api/master/provinces"
}
  return await axios.post(config.API_URL+"path/",parms, { headers: authHeader() });
};

const getAmphurs = async (provinceId) => {
  let parms = {
    path: `api/master/amphurs/${provinceId}`
}
  return await axios.post(config.API_URL+"path/",parms, { headers: authHeader() });
};


const postAdd = async (register) => {
  let parms = {
    path: "api/register/signup",
    register:register
}
  return await axios.post(config.API_URL+"path/",parms, { headers: authHeader() });
};



const getSettings = async () => {
  let parms = {
     path: "api/master/settings"
}

  return await axios.post(config.API_URL+"path/",parms, { headers: authHeader() });
};

export default {
 
  
  
  getProvinces,
  getAmphurs,
  postAdd,
  getSettings
};